import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

// Read shape of one data row from view__account_commitments_tablegrid. Total
// rows (carrying _total_label) are filtered out before validation by the
// service, so this models a commitment row only. Passthrough tolerates the
// raw numeric companions (_amount, _management_fee_rate, …) the RPC also emits.
export const AccountCommitmentGridModelSchema = z
  .object({
    fund_commitments__id: z.string(),
    funds__id: z.string().nullish(),
    funds__name: z.string().nullish(),
    investors__id: z.string().nullish(),
    investors__name: z.string().nullish(),
    investors__legal_name: z.string().nullish(),
    fund_commitment_statuses__id: z.union([z.string(), z.number()]).nullish(),
    fund_commitment_statuses__label: z.string().nullish(),
    currency_code: z.string().nullish(),
    currency_symbol: z.string().nullish(),
    fund_commitments__amount_fmt: z.string().nullish(),
    fund_commitments__date_committed_fmt: z.string().nullish(),
    fund_commitments__date_closed_fmt: z.string().nullish(),
    fund_commitments__management_fee_rate_fmt: z.string().nullish(),
    fund_commitments__base_carry_rate_fmt: z.string().nullish(),
    fund_commitments__base_hurdle_multiple_fmt: z.string().nullish(),
    fund_commitments__stepped_carry_rate_fmt: z.string().nullish(),
    fund_commitments__stepped_hurdle_multiple_fmt: z.string().nullish()
  })
  .passthrough()

export type AccountCommitmentGridModel = z.infer<typeof AccountCommitmentGridModelSchema>

export function validateAccountCommitmentGridModel(data: unknown): AccountCommitmentGridModel {
  try {
    return validateWithZodSchema(AccountCommitmentGridModelSchema, data, 'account commitment grid model')
  } catch (error) {
    throw new Error(`Account commitment grid model validation failed: ${error}`)
  }
}
